var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0637 5.55592L19.7097 4.84512C20.4525 4.02767 20.3921 2.76279 19.5747 2.01991C18.7572 1.27704 17.4923 1.33749 16.7495 2.15493L13.6587 5.55592H11.6318L15.6394 1.14611C16.9394 -0.28441 19.153 -0.390198 20.5835 0.909831C21.918 2.12263 22.0996 4.13048 21.0625 5.55592H19.0637Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91578 5.55592L6.26982 4.84512C5.52694 4.02767 5.58739 2.76279 6.40484 2.01991C7.22228 1.27704 8.48716 1.33749 9.23004 2.15493L12.3208 5.55592H14.3477L10.3401 1.14611C9.04009 -0.28441 6.82654 -0.390198 5.39602 0.909831C4.06148 2.12263 3.87987 4.13048 4.91701 5.55592H6.91578Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 6.5H10.75V23.5H15.75V6.5ZM9.25 5V25H17.25V5H9.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 6.5H22.25C23.0784 6.5 23.75 7.17157 23.75 8V11C23.75 11.8284 23.0784 12.5 22.25 12.5H19.25V14H22.25C23.9069 14 25.25 12.6569 25.25 11V8C25.25 6.34315 23.9069 5 22.25 5H3.25C1.59315 5 0.25 6.34315 0.25 8V11C0.25 12.6569 1.59315 14 3.25 14H7.25V12.5H3.25C2.42157 12.5 1.75 11.8284 1.75 11V8C1.75 7.17157 2.42157 6.5 3.25 6.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.25 13.2363C23.8369 13.606 23.3208 13.863 22.75 13.9587V22.0002C22.75 22.8286 22.0784 23.5002 21.25 23.5002H4.25C3.42157 23.5002 2.75 22.8286 2.75 22.0002V13.9587C2.17921 13.863 1.66308 13.606 1.25 13.2363V13.5002V22.0002C1.25 23.6571 2.59315 25.0002 4.25 25.0002H21.25C22.9069 25.0002 24.25 23.6571 24.25 22.0002V13.5002V13.2363Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reward.0dabaf6ffdba252abc4db7892c0a6ecc.svg";